import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { MyContext } from '../../context';
import DataTable from '../../components/tables/DataTable';
import Pagination from '../../components/Pagination';
import { listStoreAccounts } from '../../utils/queries';

const PAGE_SIZE = 25;

export default function StoreAccountsList() {
	const { activeStoreId } = useContext(MyContext);
	const [accounts, setAccounts] = useState([]);
	const [total, setTotal] = useState(0);
	const [page, setPage] = useState(0);
	const [loading, setLoading] = useState(true);
	const [search, setSearch] = useState('');

	useEffect(() => {
		setLoading(true);
		listStoreAccounts({
			limit: PAGE_SIZE,
			offset: page * PAGE_SIZE,
			search: search || undefined,
			storeId: activeStoreId || undefined,
		}).then((result) => {
			if (result?.success) {
				setAccounts(result.data.store_accounts);
				setTotal(result.data.pagination.total);
			}
			setLoading(false);
		});
	}, [page, search, activeStoreId]);

	const columns = [
		{
			key: 'email',
			header: 'Email',
			render: (value, row) => (
				<Link to={`/store-accounts/${row.customerAccountId}`} className='text-black font-medium hover:underline'>
					{value}
				</Link>
			),
		},
		{
			key: 'firstName',
			header: 'Name',
			render: (value, row) => `${value || ''} ${row.lastName || ''}`.trim() || '-',
		},
		{ key: 'phone', header: 'Phone', render: (value) => value || '-' },
		// {
		// 	key: 'emailVerifiedAt',
		// 	header: 'Verified',
		// 	render: (value) => (value ? 'Yes' : 'No'),
		// },
		{
			key: 'customerId',
			header: 'ERP',
			render: (value) => (value ? 'Yes' : 'No'),
		},
		{
			key: 'addedDate',
			header: 'Created',
			render: (value) => (value ? new Date(value).toLocaleDateString() : ''),
		},
	];

	return (
		<div className='py-8 pr-8'>
			<h1 className='text-2xl font-light tracking-tight mb-6'>Accounts</h1>
			<p className='text-sm text-gray-500 mb-6'>
				The user accounts with access to the store. For ERP customers, see{' '}
				<Link to='/customers' className='underline hover:text-black'>
					ERP Customers
				</Link>
				.
			</p>

			<div className='mb-5'>
				<label>Search</label>
				<div className='relative max-w-sm'>
					<Search className='pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 size-4 text-gray-400' />
					<input
						className='w-52 form-input pl-9'
						value={search}
						onChange={(e) => {
							setSearch(e.target.value);
							setPage(0);
						}}
					/>
				</div>
			</div>

			<DataTable columns={columns} data={accounts} loading={loading} emptyHeading='No store users found' />
			<Pagination pageCount={Math.ceil(total / PAGE_SIZE)} currentPage={page} onPageChange={setPage} />
		</div>
	);
}
